import { createSlice } from "@reduxjs/toolkit";
import { Subscribed } from "../Actions/Adminactions";
import { toast } from "react-toastify";

export const SubscribeSlice = createSlice({
  name: "SubscribeSlice",
  initialState: {
    data: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Subscribed.fulfilled, (state, action) => {
      if(action?.payload?.success){
        state.data=action.payload
      }else{
      toast.error(action?.payload?.success)
      }
    });
  },
});

export default SubscribeSlice.reducer;
